import React from 'react';
import { Link } from 'react-router-dom';
import './BoardFloatPrompt.scss';

const BoardFloatPrompt: React.FC = () => {
  return (
    <Link to="/forum" className="board-float-prompt">
      <span className="board-float-prompt__txt">
        <span className="board-float-prompt__ttl">掲示板で募集する</span>
        <span className="board-float-prompt__sub">良いドナーが見つからない方へ</span>
      </span>
      <span className="board-float-prompt__chev" aria-hidden="true">›</span>
    </Link>
  );
};

export default BoardFloatPrompt;
